import { Hidden, IconButton, useMediaQuery } from "@material-ui/core";
import React from "react";
import { Link, useHistory } from "react-router-dom";

import { ReactComponent as CloseIcon } from "assets/close.svg";
import { ReactComponent as CorporateImage } from "assets/corporate-fitness.svg";
import { StyledGrid, StyledP } from "components/simple";
import {
  breakpoints,
  color,
  fontFamily,
  fontSize,
  iconSizes,
  spacingDefaults
} from "style/constants";
import routesConfig from "utils/routesConfig";

interface SurveyBannerProps {
  dismiss(): Promise<void>;
  firstName?: string;
}

const SurveyBanner: React.FC<SurveyBannerProps> = ({
  dismiss,
  firstName
}: SurveyBannerProps) => {
  const mobile = useMediaQuery(`(max-width:${breakpoints.lg}px)`);
  const history = useHistory();

  return (
    <StyledGrid
      alignItems="center"
      backgroundColor={color.WHITE}
      borderRadius="8px"
      container
      overflow={mobile ? "hidden" : undefined}
      padding="20px"
      position="relative"
      onClick={
        mobile
          ? () => history.push(routesConfig.surveys.survey.path)
          : undefined
      }
    >
      <Hidden mdDown>
        <StyledGrid item height="50px" position="relative">
          <CorporateImage
            height={440}
            style={{
              position: "absolute",
              top: "-210px"
            }}
            width={240}
          />
        </StyledGrid>

        <StyledGrid container direction="column" item marginLeft="300px" xs>
          <StyledGrid item marginBottom={spacingDefaults.xsmall}>
            <StyledP
              color={color.BLACK}
              fontFamily={fontFamily.secondary}
              fontSize={fontSize.large}
              aria-label="fit"
            >
              <strong>{firstName}</strong>, how fit does your brain feel?
            </StyledP>
          </StyledGrid>

          <StyledP color={color.BLACK} aria-label="performance">
            Tell us how training has impacted your daily performance.
          </StyledP>

          <Link to={routesConfig.surveys.survey.path} aria-label="go-to-survey">
            <StyledP color={color.BLACK} margintop={spacingDefaults.small}>
              <strong>Take Survey (2 min) &gt;</strong>
            </StyledP>
          </Link>
        </StyledGrid>
      </Hidden>
      <Hidden lgUp>
        <StyledGrid item height="0px" position="relative" width="60px">
          <CorporateImage
            height={275}
            style={{
              left: "-30px",
              position: "absolute",
              top: "-80px"
            }}
            width={115}
          />
        </StyledGrid>

        <StyledGrid container direction="column" item marginLeft="90px">
          <StyledP
            color={color.BLACK}
            fontSize={fontSize.medium}
            aria-label="performance-mobile"
          >
            Tell us how training has impacted your daily performance.
          </StyledP>

          <StyledP color={color.BLACK} aria-label="go-to-survey-mobile">
            <strong>Take Survey (2 min) &gt;</strong>
          </StyledP>
        </StyledGrid>
      </Hidden>

      <StyledGrid item position="absolute" right="5px" top="5px">
        <IconButton
          aria-label="close-notification"
          onClick={event => {
            event.stopPropagation();
            dismiss();
          }}
        >
          <CloseIcon
            stroke={color.WHITE}
            height={iconSizes.smaller}
            width={iconSizes.smaller}
          />
        </IconButton>
      </StyledGrid>
    </StyledGrid>
  );
};

export default SurveyBanner;
